export default __webpack_public_path__ + "static/media/stroller_1.7e5a52ed.png";